import type {
  TransportResourceGetDriverDetailRes,
  DriverServiceV1UpdateDriverBody,
  DriverServiceV1UpdateDriverDraftBody,
  TransportResourceCreateDriverReq,
  TransportResourceCreateDriverDraftReq,
} from "_services/modules/transport-resource/driver";

export type DriverDocumentType =
  | "skck"
  | "ktp"
  | "kk"
  | "sim"
  | "domicile_letter";

export const DRIVER_DOCUMENT_TYPES: readonly DriverDocumentType[] = [
  "skck",
  "ktp",
  "kk",
  "sim",
  "domicile_letter",
];

export const LICENSE_TYPES: { label: string; value: string }[] = [
  { label: "SIM A", value: "SIM A" },
  { label: "SIM B1", value: "SIM B1" },
  { label: "SIM B2", value: "SIM B2" },
];

export type DriverLicenseType = "SIM A" | "SIM B1" | "SIM B2";

export type DriverStatus =
  | "available"
  | "assigned"
  | "inactive"
  | "draft"
  | "active";

export interface UploadedDriverDocument {
  fileName: string;
  fileUrl: string;
  pendingFile?: File;
}

export interface DriverDocumentErrors {
  skck?: string;
  ktp?: string;
  kk?: string;
  sim?: string;
  domicile_letter?: string;
}

export type ExtendedDriverDocument = {
  document_type: string;
  document_url: string;
  expiry_date?: string;
};

export type DriverDocumentItem = {
  id?: string;
  document_type?: string;
  type?: string;
  document_url?: string;
  file_url?: string;
  created_at?: string;
  expiry_date?: string;
};

export type ExtendedDriverDetailRes = TransportResourceGetDriverDetailRes & {
  driver_code?: string;
  driver_id?: string;
  join_date?: string;
  driver_picture_url?: string;
  documents?: DriverDocumentItem[];
};

export type ExtendedUpdateDriverBody = Omit<DriverServiceV1UpdateDriverBody, "documents"> & {
  join_date?: string;
  documents?: ExtendedDriverDocument[];
};

export type ExtendedUpdateDriverDraftBody = Omit<DriverServiceV1UpdateDriverDraftBody, "documents"> & {
  driver_code?: string;
  join_date?: string;
  documents?: ExtendedDriverDocument[];
};

export type ExtendedCreateDriverReq = Omit<TransportResourceCreateDriverReq, "documents"> & {
  driver_code?: string;
  join_date?: string;
  documents?: ExtendedDriverDocument[];
};

export type ExtendedCreateDriverDraftReq = Omit<TransportResourceCreateDriverDraftReq, "documents"> & {
  driver_code?: string;
  join_date?: string;
  documents?: ExtendedDriverDocument[];
};

export interface DriverFormValues {
  driverName: string;
  ktpNumber: string;
  driverId?: string;
  joinDate?: string;

  phoneCountryCode: string;
  phoneNumber: string;

  associatedVendor: string;

  domicileAddress: string;
  citizenAddress: string;

  isSameAddress: boolean;

  status: "active" | "available" | "inactive";

  emergencyName: string;
  emergencyRelation: string;

  emergencyPhoneCountryCode: string;
  emergencyPhoneNumber: string;

  bankName: string;
  bankAccountNumber: string;
  bankAccountHolder: string;

  licenseType: string;
  licenseNumber: string;
  licenseExpiryDate: string;
  gender: string;
  maritalStatus: string;
  email: string;

  creationMethod:
    | "invitation"
    | "manual";

  password: string;
}

export interface DriverRow {
  id: string;
  driverName: string;
  vendor: string;
  vendorCode?: string;
  driverPictureUrl?: string;
  phone: string;
  status: DriverStatus;
  licenseType?: string;
  licenseNumber: string;
  rating?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: {
    name?: string;
    timestamp?: string;
  };
  updatedBy?: {
    name?: string;
    timestamp?: string;
  };
}